import { useCallback, useEffect, useState } from "react"
import DivisaService from "../services/divisaService"

export const useCurrency = () => {
  const [loading, setLoading] = useState(true)
  const [currencyList, setCurrencyList] = useState([])
  const [currencyListFormatDropdown, setCurrencyListDropdown] = useState([])

  const fetchDivisas = useCallback(async () => {
    try {
      setLoading(true)

      const {
        data: { items },
      } = await DivisaService.getDivisas()
      setCurrencyList(items)
      setCurrencyListDropdown(
        items.map(
          ({ descripcion, abreviatura, simbolo }: $TSMigrationFixMe) => ({
            label: `${descripcion} (${simbolo})`,
            value: abreviatura,
            simbolo,
          })
        )
      )
    } finally {
      setLoading(false)
    }
  }, [])

  const getSymbol = (shortcode: $TSMigrationFixMe) =>
    currencyList.find(({ abreviatura = "" }) => abreviatura === shortcode)
  const getAbreviatura = (currencySymbol: $TSMigrationFixMe) =>
    currencyList.find(({ simbolo = "" }) => simbolo === currencySymbol)

  // FIX: Multiple calls to fetchDivisas. Without this, currency is undefined when you try to convertirFacturas
  useEffect(() => {
    fetchDivisas()
  }, [fetchDivisas])

  return {
    loading,
    currencyList,
    currencyListFormatDropdown,
    getSymbol,
    getAbreviatura,
    fetchDivisas,
  }
}
